// action
import {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  apiErrorChange,
} from "./reducer";
import { postEntityUserData } from "../../../helpers/AuthType/authBackend";

// Is user register successfull then direct plot user in redux.
export const registerUser =
  (user: any, history: any) => async (dispatch: any) => {
    try {
      let response;

      if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
        response = await postEntityUserData(user);
        const data: any = response;
        dispatch(registerUserSuccessful(data));
      }
      history("/login");
    } catch (error) {
      dispatch(registerUserFailed(error));
      console.log(error);
    }
  };

export const resetRegisterFlag = () => {
  try {
    const response = resetRegisterFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};

export const apiError = () => {
  try {
    const response = apiErrorChange("");
    return response;
  } catch (error) {
    return error;
  }
};
